import _ from 'lodash'
import { UNKNOWN } from '../constants'

import { getRouteConfig } from './path'
import { performanceNowAvailable } from '../compatibility'

export function safeComputeInteger(func) {
    try {
        const value = Math.round(parseFloat(func()))
        return _.isFinite(value) ? value : undefined
    } catch (e) {
        return undefined
    }
}

export function tryCall(func, defaultValue = undefined) {
    try {
        return func()
    } catch (e) {
        return defaultValue
    }
}

export function getThreeDecimals(float) {
    try {
        const value = Math.round(float * 1000)/1000
        return _.isFinite(value) ? value : undefined
    } catch (e) {
        return undefined
    }
}

export function now() {
    return performanceNowAvailable() ? performance.now() : Date.now()
}

export function currentRouteChannelEnabled(channel) {
    const currentRoute = getRouteConfig()
    return currentRoute[channel] && currentRoute[channel].enabled
}

export function getCurrentRouteChannelExtra(channel) {
    const currentRoute = getRouteConfig()
    const defaultExtra = {
        businessType: UNKNOWN,
        businessChildType: UNKNOWN,
    };
    return currentRoute[channel] ? (currentRoute[channel].extraInfo || defaultExtra) : defaultExtra;
}

export function transformToCamelCase(obj) {
    if (!obj) {
        return {};
    }
    const r = {};
    Object.keys(obj).forEach(k => {
        const key = k
            .split('_')
            .map((p, index) => {
                if (index === 0) {
                    return p;
                }

                return p.charAt(0).toUpperCase() + p.slice(1).toLowerCase()
            })
            .join("");
        r[key] = obj[k];
    });

    return r;
}
